import { render, staticRenderFns } from "./AthleteCell.vue?vue&type=template&id=00bf4fe0&scoped=true&"
import script from "./AthleteCell.vue?vue&type=script&lang=js&"
export * from "./AthleteCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf4fe0",
  null
  
)

export default component.exports